import React from "react";
import { windowsColorToHex } from "../../utils/colors";

import "./ColorFormatter.css";

export const colorFormatter = (cell, row) => {
  const color = windowsColorToHex(cell);

  return (
    <div className="flex items-center justify-center w-full overflow-visible">
      {color ? (
        <div
          className="w-6 h-6 border rounded-sm aspect-square border-gray-50"
          style={{
            backgroundColor: color,
          }}
        />
      ) : (
        <div className="w-6 h-6 border rounded-sm stripped-square border-gray-50" />
      )}
    </div>
  );
};
